export enum ActionNames {
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  GET_BALANCE = 'GET_BALANCE',
  ORDER_HISTORY = 'ORDER_HISTORY',
  INVOICES = 'INVOICES',
  GET_LICENSES = 'GET_LICENSES',
  ADD_LICENSE = 'ADD_LICENSE',
  DELETE_LICENSE = 'DELETE_LICENSE',
  GET_USER_INFORMATION = 'GET_USER_INFORMATION',
  GET_PRIMARY_LICENSE = 'GET_PRIMARY_LICENSE',
  GET_ARTICLES = 'GET_ARTICLES',
  UPDATE_USER_DATA = 'UPDATE_USER_DATA',
  CREATE_ORDER = 'CREATE_ORDER',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD',
  CREATE_INVOICE = 'CREATE_INVOICE',
  UPDATE_ADDRESS = 'UPDATE_ADDRESS',
  UPDATE_BUSINESS_DATA = 'UPDATE_BUSINESS_DATA',
}
